var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "class_dialog" },
    [
      _c("div", { staticClass: "dialog_box" }, [
        _c("div", { staticClass: "dialog_message" }, [
          _vm._v("手机浏览器暂不支持查看该课件"),
          _c("br"),
          _vm._v('你可在"' + _vm._s(_vm.appname) + 'APP"进行查看')
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { on: { click: _vm.cancel_flag } }, [_vm._v("取消")]),
          _vm._v(" "),
          _vm.android
            ? _c("span", { staticClass: "goapp" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        _vm.scheme +
                        "?type=2&sso_id=" +
                        _vm.sso_id +
                        "&orderSn=" +
                        _vm.data.order_id +
                        "&package_id=" +
                        _vm.data.package_id +
                        "&cid=" +
                        _vm.data.cid +
                        "&menu_id=" +
                        _vm.data.menu_id +
                        "&spuID=" +
                        _vm.data.shopid +
                        "&owner=" +
                        _vm.owner +
                        "&channel=" +
                        _vm.channel +
                        "&orgn=" +
                        _vm.orgn
                    },
                    on: { click: _vm.search_flag }
                  },
                  [_vm._v("打开APP\n        ")]
                )
              ])
            : _vm.ios
            ? _c(
                "span",
                { staticClass: "goapp", on: { click: _vm.search_flag } },
                [_vm._v("去APP查看")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a891794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a891794","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/goapp.vue
// module id = null
// module chunks = 